module.exports = __webpack_public_path__ + "static/media/CircularStd-Medium.0afc4e78.woff2";